import {
  ImportSongWithoutFiles,
  ImportStatusType,
} from 'app/components/Import';
import { WsImportResourceStatus } from 'types/websocket.types';

export interface ImportState {
  guid?: string;
  songs: ImportSongWithoutFiles[];
  csv?: {
    path?: string;
    rowCount?: number;
    rowsProcessed?: number;
    status: WsImportResourceStatus;
    error?: {
      errorCode?: string;
      message: string;
    };
  };
  status?: ImportStatusType;
}

export const importInitialState: ImportState = {
  songs: [],
};

export const getimportStatus = (songs: ImportSongWithoutFiles[]) => {
  const hasFailedAudiosstate = songs.some(({ audios }) =>
    audios.some(({ status }) => status === 'failed')
  );

  const hasSomethingToUpload = songs.some(
    ({ audios, lyrics }) => audios.length > 0 || lyrics
  );

  return hasFailedAudiosstate || !hasSomethingToUpload
    ? 'inconsistent'
    : 'in_progress';
};

export const isImportDone = (songs: ImportSongWithoutFiles[]) =>
  !songs.some(
    ({ audios, lyrics }) =>
      (audios.length > 0 &&
        audios.some(({ status }) => status === 'loading')) ||
      (lyrics && lyrics.status === 'loading')
  );
